import { SkipBackwardIcon } from './SkipBackwardIcon';

/**
 * author: Simran
 * id 45260E4C-E8EB-4E35-85A8-F19A91FE1A2C
 * name skip-backward
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/skip-backward.svg
 * tags
 * - Home Automation 
 */
export const PreviousTitleIcon = SkipBackwardIcon;
export default PreviousTitleIcon